module.exports = __webpack_public_path__ + "static/media/settings_o.2e84203d.svg";